import * as TypeGraphQL from "type-graphql";
export var FeatureImportanceAnalysisType;
(function (FeatureImportanceAnalysisType) {
    FeatureImportanceAnalysisType["SHAP"] = "SHAP";
    FeatureImportanceAnalysisType["PERMUTATION"] = "PERMUTATION";
    FeatureImportanceAnalysisType["LIME"] = "LIME";
    FeatureImportanceAnalysisType["INTEGRATED_GRADIENTS"] = "INTEGRATED_GRADIENTS";
    FeatureImportanceAnalysisType["FEATURE_ABLATION"] = "FEATURE_ABLATION";
})(FeatureImportanceAnalysisType || (FeatureImportanceAnalysisType = {}));
TypeGraphQL.registerEnumType(FeatureImportanceAnalysisType, {
    name: "FeatureImportanceAnalysisType",
    description: undefined,
});
//# sourceMappingURL=FeatureImportanceAnalysisType.js.map